import React, { useState, useEffect, useRef } from 'react';
import './MenuSection.css';
import ClubMenuCards from './ClubMenuCards';
import Package from './Package';
import Event from './Event';
import Gallery from './Gallery';
import Teaser from './Teaser';
import PartyPackageMenu from './PartyPackageMenu';
import AboutvenueDetails from './AboutvenueDetails';
import ReviewSectionDetailPage from './ReviewSectionDetailPage';
import { useParams, useNavigate } from 'react-router-dom';
import foodImg from '../../Assets/good-img.jpg';

export default function MenuSection({ partypackages, data, events, gallery, teasers, menus, isPartyPackage }) {
    const { packagedetail, title, tab, clubInfo, id } = useParams();
    const navigate = useNavigate();



    // Tab definitions
    const tabs1 = ['overview', 'menu', 'package', 'event', 'gallery', 'teaser', 'about', 'review'];
    const tabs2 = ['overview', 'menu', 'event', 'gallery', 'teaser', 'about', 'review'];
    const validTabs = !isPartyPackage ? tabs1 : tabs2;

    // Normalize URL tab param
    const normalizedTab = validTabs.includes(tab?.toLowerCase()) ? tab.toLowerCase() : 'overview';

    const [activeTab, setActiveTab] = useState(normalizedTab);

    useEffect(() => {
        setActiveTab(normalizedTab);
    }, [normalizedTab]);


    // Handle tab click → update URL
    const handleTabClick = (tab) => {
        setActiveTab(tab);

        if (id) {
            if (tab === 'overview') {
                // ✅ keep id in URL when switching tabs in bid-detail mode
                navigate(`/bid-detail/${packagedetail}/${title}/${id}`);

            } else {
                navigate(`/bid-detail/${packagedetail}/${title}/${id}/${tab}`);
            }
        }
        else if (isPartyPackage) {
            if (tab === 'overview') {
                navigate(`/party-package/${packagedetail}/${title}`);
            } else {
                navigate(`/party-package/${packagedetail}/${title}/${tab}`);
            }
        } else {
            if (tab === 'overview') {
                navigate(`/${clubInfo}`);
            } else {
                navigate(`/${clubInfo}/${tab}`);
            }
        }
    };


    const navbarRef = useRef(null);
    const [isTop, setIsTop] = useState(true);

    useEffect(() => {
        const handleScroll = () => {
            if (!navbarRef.current) return;

            const rect = navbarRef.current.getBoundingClientRect();
            // ✅ if the top of the navbar <= 30px (sticky offset), we say "scrolled"
            setIsTop(rect.top <= 30 ? false : true);
        };

        window.addEventListener("scroll", handleScroll);
        handleScroll(); // run on mount

        return () => window.removeEventListener("scroll", handleScroll);
    }, []);


    return (
        <div className='vcdp-MenuSection'>
            <div className="vcdp-container-section">

                {/* Hero Section */}
                <div ref={navbarRef} className={`${isTop ? "vcdp-sec-navbar-not-sticky" : "vcdp-sec-navbar"}`}>
                    {/* Tabs */}
                    <div className="vcdp-list-menu-tab">
                        <ul>
                            {validTabs.map((tabItem) => (
                                <li
                                    key={tabItem}
                                    className={activeTab === tabItem ? 'vcdp-active' : ''}
                                    onClick={() => handleTabClick(tabItem)}
                                >
                                    <span>{tabItem.charAt(0).toUpperCase() + tabItem.slice(1)}</span>
                                </li>
                            ))}
                        </ul>
                    </div>
                </div>


                {/* <div className='A-la-carte-menu'>
                    <div className="row row-cols-2 row-cols-lg-2 g-2 g-lg-3">
                        <div className="col">
                            <div className='menucard d-flex gap-3'>
                                <div>
                                    <img src={foodImg} alt="Example"  />
                                </div>
                                <div className='d-flex flex-column gap-2'>
                                    <h5 className='d-flex font-16 text-black m-0'>
                                        <span className='icon-span-24'>
                                            <svg xmlns="http://www.w3.org/2000/svg" width="16"  viewBox="0 0 14 15" fill="none">
                                                <path d="M10.6667 2.16659C11.403 2.16659 12 2.76354 12 3.49992V11.4999C12 12.2363 11.403 12.8333 10.6667 12.8333H2.66667C1.93029 12.8333 1.33333 12.2363 1.33333 11.4999V3.49992C1.33333 2.76354 1.93029 2.16659 2.66667 2.16659H10.6667ZM13.3333 2.16658C13.3333 1.4302 12.7364 0.833252 12 0.833252H1.33333C0.596952 0.833252 0 1.43021 0 2.16659V12.8333C0 13.5696 0.596954 14.1666 1.33333 14.1666H12C12.7364 14.1666 13.3333 13.5696 13.3333 12.8333V2.16658ZM6.66667 3.49992C4.46 3.49992 2.66667 5.29325 2.66667 7.49992C2.66667 9.70659 4.46 11.4999 6.66667 11.4999C8.87333 11.4999 10.6667 9.70659 10.6667 7.49992C10.6667 5.29325 8.87333 3.49992 6.66667 3.49992Z" fill="#16A34A"/>
                                                </svg>
                                        </span>
                                        Warm Quinoa Salad
                                    </h5>
                                    <p>Refreshing blend of white rum, mint leaves, lime, sugar, and soda water.</p>
                                    <div className='d-flex gap-1 '>
                                        <button type="button" class="btn btn-warning btn-set-menu yellow-light">Bestseller</button>
                                        <button type="button" class="btn btn-success btn-set-menu green-light">Fresh Ingredients</button>
                                        <button type="button" class="btn btn-info btn-set-menu begni-light">Light & Refreshing</button>
                                    </div>
                                </div>

                                <div className='price-tag-al-carte'>
                                    ₹349
                                </div>


                            </div>
                        </div>
                        <div className="col">
                            <div className='menucard d-flex gap-3'>
                                <div>
                                    <img src={foodImg} alt="Example"  />
                                </div>
                                <div className='d-flex flex-column gap-2'>
                                    <h5 className='d-flex font-16 text-black m-0'>
                                        <span className='icon-span-24'>
                                            <svg xmlns="http://www.w3.org/2000/svg" width="16"  viewBox="0 0 14 15" fill="none">
                                                <path d="M10.6667 2.16659C11.403 2.16659 12 2.76354 12 3.49992V11.4999C12 12.2363 11.403 12.8333 10.6667 12.8333H2.66667C1.93029 12.8333 1.33333 12.2363 1.33333 11.4999V3.49992C1.33333 2.76354 1.93029 2.16659 2.66667 2.16659H10.6667ZM13.3333 2.16658C13.3333 1.4302 12.7364 0.833252 12 0.833252H1.33333C0.596952 0.833252 0 1.43021 0 2.16659V12.8333C0 13.5696 0.596954 14.1666 1.33333 14.1666H12C12.7364 14.1666 13.3333 13.5696 13.3333 12.8333V2.16658ZM6.66667 3.49992C4.46 3.49992 2.66667 5.29325 2.66667 7.49992C2.66667 9.70659 4.46 11.4999 6.66667 11.4999C8.87333 11.4999 10.6667 9.70659 10.6667 7.49992C10.6667 5.29325 8.87333 3.49992 6.66667 3.49992Z" fill="#16A34A"/>
                                                </svg>
                                        </span>
                                        Warm Quinoa Salad
                                    </h5>
                                    <p>Refreshing blend of white rum, mint leaves, lime, sugar, and soda water.</p>
                                    <div className='d-flex gap-1 '>
                                        <button type="button" class="btn btn-warning btn-set-menu yellow-light">Bestseller</button>
                                        <button type="button" class="btn btn-success btn-set-menu green-light">Fresh Ingredients</button>
                                        <button type="button" class="btn btn-info btn-set-menu begni-light">Light & Refreshing</button>
                                    </div>
                                </div>

                                <div className='price-tag-al-carte'>
                                    ₹349
                                </div>


                            </div>
                        </div>
                        <div className="col">
                            <div className='menucard d-flex gap-3'>
                                <div>
                                    <img src={foodImg} alt="Example"  />
                                </div>
                                <div className='d-flex flex-column gap-2'>
                                    <h5 className='d-flex font-16 text-black m-0'>
                                        <span className='icon-span-24'>
                                            <svg xmlns="http://www.w3.org/2000/svg" width="16"  viewBox="0 0 14 15" fill="none">
                                                <path d="M10.6667 2.16659C11.403 2.16659 12 2.76354 12 3.49992V11.4999C12 12.2363 11.403 12.8333 10.6667 12.8333H2.66667C1.93029 12.8333 1.33333 12.2363 1.33333 11.4999V3.49992C1.33333 2.76354 1.93029 2.16659 2.66667 2.16659H10.6667ZM13.3333 2.16658C13.3333 1.4302 12.7364 0.833252 12 0.833252H1.33333C0.596952 0.833252 0 1.43021 0 2.16659V12.8333C0 13.5696 0.596954 14.1666 1.33333 14.1666H12C12.7364 14.1666 13.3333 13.5696 13.3333 12.8333V2.16658ZM6.66667 3.49992C4.46 3.49992 2.66667 5.29325 2.66667 7.49992C2.66667 9.70659 4.46 11.4999 6.66667 11.4999C8.87333 11.4999 10.6667 9.70659 10.6667 7.49992C10.6667 5.29325 8.87333 3.49992 6.66667 3.49992Z" fill="#16A34A"/>
                                                </svg>
                                        </span>
                                        Warm Quinoa Salad
                                    </h5>
                                    <p>Refreshing blend of white rum, mint leaves, lime, sugar, and soda water.</p>
                                    <div className='d-flex gap-1 '>
                                        <button type="button" class="btn btn-warning btn-set-menu yellow-light">Bestseller</button>
                                        <button type="button" class="btn btn-success btn-set-menu green-light">Fresh Ingredients</button>
                                        <button type="button" class="btn btn-info btn-set-menu begni-light">Light & Refreshing</button>
                                    </div>
                                </div>

                                <div className='price-tag-al-carte'>
                                    ₹349
                                </div>


                            </div>
                        </div>
                        <div className="col">
                            <div className='menucard d-flex gap-3'>
                                <div>
                                    <img src={foodImg} alt="Example"  />
                                </div>
                                <div className='d-flex flex-column gap-2'>
                                    <h5 className='d-flex font-16 text-black m-0'>
                                        <span className='icon-span-24'>
                                            <svg xmlns="http://www.w3.org/2000/svg" width="16"  viewBox="0 0 14 15" fill="none">
                                                <path d="M10.6667 2.16659C11.403 2.16659 12 2.76354 12 3.49992V11.4999C12 12.2363 11.403 12.8333 10.6667 12.8333H2.66667C1.93029 12.8333 1.33333 12.2363 1.33333 11.4999V3.49992C1.33333 2.76354 1.93029 2.16659 2.66667 2.16659H10.6667ZM13.3333 2.16658C13.3333 1.4302 12.7364 0.833252 12 0.833252H1.33333C0.596952 0.833252 0 1.43021 0 2.16659V12.8333C0 13.5696 0.596954 14.1666 1.33333 14.1666H12C12.7364 14.1666 13.3333 13.5696 13.3333 12.8333V2.16658ZM6.66667 3.49992C4.46 3.49992 2.66667 5.29325 2.66667 7.49992C2.66667 9.70659 4.46 11.4999 6.66667 11.4999C8.87333 11.4999 10.6667 9.70659 10.6667 7.49992C10.6667 5.29325 8.87333 3.49992 6.66667 3.49992Z" fill="#16A34A"/>
                                                </svg>
                                        </span>
                                        Warm Quinoa Salad
                                    </h5>
                                    <p>Refreshing blend of white rum, mint leaves, lime, sugar, and soda water.</p>
                                    <div className='d-flex gap-1 '>
                                        <button type="button" class="btn btn-warning btn-set-menu yellow-light">Bestseller</button>
                                        <button type="button" class="btn btn-success btn-set-menu green-light">Fresh Ingredients</button>
                                        <button type="button" class="btn btn-info btn-set-menu begni-light">Light & Refreshing</button>
                                    </div>
                                </div>

                                <div className='price-tag-al-carte'>
                                    ₹349
                                </div>


                            </div>
                        </div>
                        <div className="col">
                            <div className='menucard d-flex gap-3'>
                                <div>
                                    <img src={foodImg} alt="Example"  />
                                </div>
                                <div className='d-flex flex-column gap-2'>
                                    <h5 className='d-flex font-16 text-black m-0'>
                                        <span className='icon-span-24'>
                                            <svg xmlns="http://www.w3.org/2000/svg" width="16"  viewBox="0 0 14 15" fill="none">
                                                <path d="M10.6667 2.16659C11.403 2.16659 12 2.76354 12 3.49992V11.4999C12 12.2363 11.403 12.8333 10.6667 12.8333H2.66667C1.93029 12.8333 1.33333 12.2363 1.33333 11.4999V3.49992C1.33333 2.76354 1.93029 2.16659 2.66667 2.16659H10.6667ZM13.3333 2.16658C13.3333 1.4302 12.7364 0.833252 12 0.833252H1.33333C0.596952 0.833252 0 1.43021 0 2.16659V12.8333C0 13.5696 0.596954 14.1666 1.33333 14.1666H12C12.7364 14.1666 13.3333 13.5696 13.3333 12.8333V2.16658ZM6.66667 3.49992C4.46 3.49992 2.66667 5.29325 2.66667 7.49992C2.66667 9.70659 4.46 11.4999 6.66667 11.4999C8.87333 11.4999 10.6667 9.70659 10.6667 7.49992C10.6667 5.29325 8.87333 3.49992 6.66667 3.49992Z" fill="#16A34A"/>
                                                </svg>
                                        </span>
                                        Warm Quinoa Salad
                                    </h5>
                                    <p>Refreshing blend of white rum, mint leaves, lime, sugar, and soda water.</p>
                                    <div className='d-flex gap-1 '>
                                        <button type="button" class="btn btn-warning btn-set-menu yellow-light">Bestseller</button>
                                        <button type="button" class="btn btn-success btn-set-menu green-light">Fresh Ingredients</button>
                                        <button type="button" class="btn btn-info btn-set-menu begni-light">Light & Refreshing</button>
                                    </div>
                                </div>

                                <div className='price-tag-al-carte'>
                                    ₹349
                                </div>


                            </div>
                        </div>
                        <div className="col">
                            <div className='menucard d-flex gap-3'>
                                <div>
                                    <img src={foodImg} alt="Example"  />
                                </div>
                                <div className='d-flex flex-column gap-2'>
                                    <h5 className='d-flex font-16 text-black m-0'>
                                        <span className='icon-span-24'>
                                            <svg xmlns="http://www.w3.org/2000/svg" width="16"  viewBox="0 0 14 15" fill="none">
                                                <path d="M10.6667 2.16659C11.403 2.16659 12 2.76354 12 3.49992V11.4999C12 12.2363 11.403 12.8333 10.6667 12.8333H2.66667C1.93029 12.8333 1.33333 12.2363 1.33333 11.4999V3.49992C1.33333 2.76354 1.93029 2.16659 2.66667 2.16659H10.6667ZM13.3333 2.16658C13.3333 1.4302 12.7364 0.833252 12 0.833252H1.33333C0.596952 0.833252 0 1.43021 0 2.16659V12.8333C0 13.5696 0.596954 14.1666 1.33333 14.1666H12C12.7364 14.1666 13.3333 13.5696 13.3333 12.8333V2.16658ZM6.66667 3.49992C4.46 3.49992 2.66667 5.29325 2.66667 7.49992C2.66667 9.70659 4.46 11.4999 6.66667 11.4999C8.87333 11.4999 10.6667 9.70659 10.6667 7.49992C10.6667 5.29325 8.87333 3.49992 6.66667 3.49992Z" fill="#16A34A"/>
                                                </svg>
                                        </span>
                                        Warm Quinoa Salad
                                    </h5>
                                    <p>Refreshing blend of white rum, mint leaves, lime, sugar, and soda water.</p>
                                    <div className='d-flex gap-1 '>
                                        <button type="button" class="btn btn-warning btn-set-menu yellow-light">Bestseller</button>
                                        <button type="button" class="btn btn-success btn-set-menu green-light">Fresh Ingredients</button>
                                        <button type="button" class="btn btn-info btn-set-menu begni-light">Light & Refreshing</button>
                                    </div>
                                </div>

                                <div className='price-tag-al-carte'>
                                    ₹349
                                </div>


                            </div>
                        </div>
                        <div className="col">
                            <div className='menucard d-flex gap-3'>
                                <div>
                                    <img src={foodImg} alt="Example"  />
                                </div>
                                <div className='d-flex flex-column gap-2'>
                                    <h5 className='d-flex font-16 text-black m-0'>
                                        <span className='icon-span-24'>
                                            <svg xmlns="http://www.w3.org/2000/svg" width="16"  viewBox="0 0 14 15" fill="none">
                                                <path d="M10.6667 2.16659C11.403 2.16659 12 2.76354 12 3.49992V11.4999C12 12.2363 11.403 12.8333 10.6667 12.8333H2.66667C1.93029 12.8333 1.33333 12.2363 1.33333 11.4999V3.49992C1.33333 2.76354 1.93029 2.16659 2.66667 2.16659H10.6667ZM13.3333 2.16658C13.3333 1.4302 12.7364 0.833252 12 0.833252H1.33333C0.596952 0.833252 0 1.43021 0 2.16659V12.8333C0 13.5696 0.596954 14.1666 1.33333 14.1666H12C12.7364 14.1666 13.3333 13.5696 13.3333 12.8333V2.16658ZM6.66667 3.49992C4.46 3.49992 2.66667 5.29325 2.66667 7.49992C2.66667 9.70659 4.46 11.4999 6.66667 11.4999C8.87333 11.4999 10.6667 9.70659 10.6667 7.49992C10.6667 5.29325 8.87333 3.49992 6.66667 3.49992Z" fill="#16A34A"/>
                                                </svg>
                                        </span>
                                        Warm Quinoa Salad
                                    </h5>
                                    <p>Refreshing blend of white rum, mint leaves, lime, sugar, and soda water.</p>
                                    <div className='d-flex gap-1 '>
                                        <button type="button" class="btn btn-warning btn-set-menu yellow-light">Bestseller</button>
                                        <button type="button" class="btn btn-success btn-set-menu green-light">Fresh Ingredients</button>
                                        <button type="button" class="btn btn-info btn-set-menu begni-light">Light & Refreshing</button>
                                    </div>
                                </div>

                                <div className='price-tag-al-carte'>
                                    ₹349
                                </div>


                            </div>
                        </div>
                        <div className="col">
                            <div className='menucard d-flex gap-3'>
                                <div>
                                    <img src={foodImg} alt="Example"  />
                                </div>
                                <div className='d-flex flex-column gap-2'>
                                    <h5 className='d-flex font-16 text-black m-0'>
                                        <span className='icon-span-24'>
                                            <svg xmlns="http://www.w3.org/2000/svg" width="16"  viewBox="0 0 14 15" fill="none">
                                                <path d="M10.6667 2.16659C11.403 2.16659 12 2.76354 12 3.49992V11.4999C12 12.2363 11.403 12.8333 10.6667 12.8333H2.66667C1.93029 12.8333 1.33333 12.2363 1.33333 11.4999V3.49992C1.33333 2.76354 1.93029 2.16659 2.66667 2.16659H10.6667ZM13.3333 2.16658C13.3333 1.4302 12.7364 0.833252 12 0.833252H1.33333C0.596952 0.833252 0 1.43021 0 2.16659V12.8333C0 13.5696 0.596954 14.1666 1.33333 14.1666H12C12.7364 14.1666 13.3333 13.5696 13.3333 12.8333V2.16658ZM6.66667 3.49992C4.46 3.49992 2.66667 5.29325 2.66667 7.49992C2.66667 9.70659 4.46 11.4999 6.66667 11.4999C8.87333 11.4999 10.6667 9.70659 10.6667 7.49992C10.6667 5.29325 8.87333 3.49992 6.66667 3.49992Z" fill="#16A34A"/>
                                                </svg>
                                        </span>
                                        Warm Quinoa Salad
                                    </h5>
                                    <p>Refreshing blend of white rum, mint leaves, lime, sugar, and soda water.</p>
                                    <div className='d-flex gap-1 '>
                                        <button type="button" class="btn btn-warning btn-set-menu yellow-light">Bestseller</button>
                                        <button type="button" class="btn btn-success btn-set-menu green-light">Fresh Ingredients</button>
                                        <button type="button" class="btn btn-info btn-set-menu begni-light">Light & Refreshing</button>
                                    </div>
                                </div>

                                <div className='price-tag-al-carte'>
                                    ₹349
                                </div>


                            </div>
                        </div>
   
                    </div>
                </div> */}





                {/* Render Active Tab Section */}
                <div className="vcdp-section-content">
                    {activeTab === 'overview' && (
                        <>
                            {isPartyPackage ? (
                                <PartyPackageMenu menus={menus} />
                            ) : (
                                <ClubMenuCards menus={menus} />
                            )}
                            {/* <Package partypackages={partypackages} /> */}
                            <Event events={events} clubName={data?.name} />
                            <Gallery gallery={gallery} />
                            <Teaser teasers={teasers} />
                            <AboutvenueDetails data={data} />
                            <ReviewSectionDetailPage data={data} />
                        </>
                    )}

                    {activeTab === 'menu' && (
                        isPartyPackage ? <PartyPackageMenu menus={menus} /> : <ClubMenuCards menus={menus} />
                    )}

                    {activeTab === 'package' && !isPartyPackage && (
                        <Package partypackages={partypackages} />
                    )}

                    {activeTab === 'event' && (
                        <Event events={events} clubName={data?.name} />
                    )}

                    {activeTab === 'gallery' && (
                        <Gallery gallery={gallery} />
                    )}

                    {activeTab === 'teaser' && (
                        <Teaser teasers={teasers} />
                    )}

                    {activeTab === 'about' && (
                        <AboutvenueDetails data={data} />
                    )}

                    {activeTab === 'review' && (
                        <ReviewSectionDetailPage data={data} />
                    )}
                </div>
            </div>




        </div >
    );
}
